import React, {useContext, useEffect, useRef} from "react";
import GeneralContext from "./context/GeneralProvider";
import Login from "./components/Login";
import Profile from "./components/Profile";
import {ToastContainer} from 'react-toastify';
import {IoReturnDownBack} from "react-icons/io5";
import {FiLogOut} from "react-icons/fi";
import {IoMdDownload} from "react-icons/io";


export default function App() {
    const {user,setUser,setVideo,setOrigin, video, origin} = useContext(GeneralContext);
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;

        let points = [];

        for (let i = 0; i < 80; i++) {
            points.push({
                x: Math.random() * canvas.width,
                y: Math.random() * canvas.height,
                vx: (Math.random() - 0.5) * 0.5,
                vy: (Math.random() - 0.5) * 0.5
            });
        }

        const mouse = { x: null, y: null };

        const mouseMoveHandler = (e) => {
            mouse.x = e.clientX;
            mouse.y = e.clientY;
        };

        window.addEventListener('mousemove', mouseMoveHandler);

        const animate = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            for (let p of points) {
                p.x += p.vx;
                p.y += p.vy;

                if (p.x < 0 || p.x > canvas.width) p.vx *= -1;
                if (p.y < 0 || p.y > canvas.height) p.vy *= -1;

                ctx.beginPath();
                ctx.arc(p.x, p.y, 2, 0, Math.PI * 2);
                ctx.fillStyle = '#00faff';
                ctx.shadowBlur = 10;
                ctx.shadowColor = '#00faff';
                ctx.fill();
                ctx.closePath();

                for (let q of points) {
                    const dx = p.x - q.x;
                    const dy = p.y - q.y;
                    const dist = Math.sqrt(dx * dx + dy * dy);
                    if (dist < 100) {
                        ctx.beginPath();
                        ctx.moveTo(p.x, p.y);
                        ctx.lineTo(q.x, q.y);
                        ctx.strokeStyle = 'rgba(0, 250, 255, 0.15)';
                        ctx.shadowBlur = 5;
                        ctx.shadowColor = '#00faff';
                        ctx.lineWidth = 1;
                        ctx.stroke();
                        ctx.closePath();
                    }
                }

                if (mouse.x && mouse.y) {
                    const dx = p.x - mouse.x;
                    const dy = p.y - mouse.y;
                    const dist = Math.sqrt(dx * dx + dy * dy);
                    if (dist < 100) {
                        p.vx += dx * 0.0005;
                        p.vy += dy * 0.0005;
                    }
                }
            }
            requestAnimationFrame(animate);
        };

        animate();

        const resizeHandler = () => {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        };

        window.addEventListener('resize', resizeHandler);

        return () => {
            window.removeEventListener('mousemove', mouseMoveHandler);
            window.removeEventListener('resize', resizeHandler);
        };
    }, []);

    const logout = (e) => {
        e.preventDefault();
        setUser("")
        setVideo("");
        setOrigin("");
        localStorage.removeItem('clerkUser');
    }

    const returnBack = (e) => {
        e.preventDefault();
        setVideo("");
        setOrigin("");
    }

    const handleDownload = async () => {
        try {
            const response = await fetch(video);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = url;
            a.download = "puma.mp4"; // İndirilecek dosyanın adı
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("İndirme sırasında hata oluştu:", error);
        }
    };

    return (
        <>
            {video && <button className="download"  onClick={handleDownload}><IoMdDownload /></button>}
            {(video || origin) && <button className="returnback" type="submit" onClick={returnBack}><IoReturnDownBack/></button>}
            {user && <button className="logout" type="submit" onClick={logout}><FiLogOut/></button>}
            <div className="container">
                <canvas ref={canvasRef}></canvas>
                <div className="overlay">
                    {!user ? <Login/> : <Profile/>}
                </div>
            </div>
            <div className="footer">"Clerk AI" - Yapay Zeka ile oluşturulmuş kişiselleştirilmiş reklamlar. <br/>Audiotime için hazırlanmış demodur!</div>
            <ToastContainer
                style={{ top: "50px", zIndex: "9999" }}
                theme="dark"
                position="top-center"
            />
        </>
    );
}
